<template>
    <div id="incidentTab" class="">
        <div class="row">
            <div class="col">
                <div class="hstack gap-3">
                    <div class="mb-3 maxwidth375">
                        <label for="eventIdentifier">Event Identifier <span
                                class="requiredfieldasterisk">*</span></label>
                        <input type="text" id="eventIdentifier"
                            v-model="contactsStore.contactFullReport!.event_identifier" class="form-control"
                            :required="true" />
                    </div>
                    <div class="mb-3 w-100 maxwidth375">

                        <SelectField v-model="contactsStore.contactFullReport!.initiation"
                            :select-items="contactsStore.getInitiationType" :is-horizontal="false" :is-required="true"
                            :ref="(el) => { addValidatableComponent(el) }">>
                            <template #label><label for="initiation" class="form-label mb-0">Initiation <span
                                        class="requiredfieldasterisk">*</span></label></template>
                        </SelectField>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <label for="dateTime" class="form-label">Date and Time <span
                                    class="requiredfieldasterisk">*</span></label>
                            <div class="hstack gap-3">
                                <Datepicker v-model="contactsStore.contactFullReport!.timestamp" :format="dateFormat"
                                    :clearable="false" :required="true" :input-class-name="'form-control'"
                                    @update:model-value="handleTimeStampUpdate($event)">
                                </Datepicker>
                            </div>
                        </li>
                        <li class="list-inline-item align-top">
                            <label for="duration" class="form-label">Duration <span
                                    class="requiredfieldasterisk">*</span></label>
                            <input type="number" id="duration" class="form-control"
                                v-model="contactsStore.contactFullReport!.duration" :required="true"
                                aria-required="true" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-4">
                <div class="mb-3">
                    <SelectField v-model="contactsStore.contactFullReport!.location_type"
                        :select-items="contactsStore.getLocationType" :is-horizontal="false" :is-required="true"
                        :ref="(el) => { addValidatableComponent(el) }">
                        <template #label><label for="locationType" class="form-label">Location Type <span
                                    class="requiredfieldasterisk">*</span></label></template>
                    </SelectField>
                </div>
            </div>
            <div class="col-md-12 col-lg-4">
                <div class="mb-3">
                    <label for="address" class="form-label">Address <span class="requiredfieldasterisk">*</span></label>
                    <input type="text" id="address" class="form-control" :required="true"
                        v-model="contactsStore.contactFullReport!.address_text" />
                </div>
            </div>
            <div class="col-md-12 col-lg-4">
                <div class="mb-3">
                    <label for="city" class="form-label">City <span class="requiredfieldasterisk">*</span></label>
                    <input type="text" id="city" class="form-control" :required="true"
                        v-model="contactsStore.contactFullReport!.city" />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3" style="width:750px">
                    <label class="form-label">Latitude / Longitude</label>
                    <div class="hstack gap-3" v-if="contactsStore.contactFullReport!.coordinates">
                        <input type="text" class="form-control" id="latitude" placeholder="Latitude"
                            v-model="contactsStore.contactFullReport!.coordinates.latitude" />
                        <input type="text" class="form-control" id="longitude" placeholder="Longitude"
                            v-model="contactsStore.contactFullReport!.coordinates.longitude" />
                    </div>
                </div>
            </div>
        </div>
        <div class=" mb-3">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="entry"
                    v-model="contactsStore.contactFullReport!.was_use_of_force" />
                <label for="wasUOF" class="">
                    Was Force Used?
                </label>
            </div>
        </div>
        <div class="mb-3">
            <div class="form-check"> <!-- set correct value for entry -->
                <input type="checkbox" class="form-check-input" id="entry" v-model="entryIntoProperty"
                    @change="handleEntryChange()" />
                <label for="wasUOF" class="">
                    Entry Into a Property?
                </label>
            </div>
            <ul class="list-group list-group-horizontal ms-3 mt-2"
                v-if="getEntryIntoProperty && contactsStore.contactFullReport!.entry_details">
                <li class="list-group-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                            v-model="contactsStore.contactFullReport!.entry_details.warrant">
                        <label class="" for="flexCheckDefault">
                            Officer had Warrant?
                        </label>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                            v-model="contactsStore.contactFullReport!.entry_details.unannounced_entry">
                        <label class="" for="flexCheckDefault">
                            Entry Unannounced?
                        </label>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                            v-model="contactsStore.contactFullReport!.entry_details.person_present">
                        <label class="" for="flexCheckDefault">
                            Person Present?
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-5">
                <div class="mb-3 container">
                    <div class="row mb-3">
                        <div class="col-6 my-auto">
                            <h4 class="mb-0">Complaints</h4>
                        </div>
                        <div class="col-6 text-end">
                            <button class="btn btn-primary" @click.prevent="handleComplaintOutcomeClick()">Add</button>
                        </div>
                    </div>
                    <div class="row border" v-for="(complaint, index) in contactFullReport!.complaint_outcome">
                        <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-10 p-2">
                            <SelectField 
                                :select-items="contactsStore.getComplaintOutcome"
                                v-model="contactFullReport!.complaint_outcome![index]" 
                                :is-horizontal="false"
                                :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField> 
                        </div>
                        <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-2 p-2 mt-1 text-end">
                            <button class="btn-close me-3" aria-label="Remove"
                                @click.prevent="handleRemove(`complaint_outcome`, contactFullReport!.complaint_outcome, index)"></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-md-none d-lg-flex col-lg-1 border-end"></div>
            <div class="d-md-none d-lg-flex col-lg-1 border-start"></div>
            <div class="col-md-12 col-lg-5">
                <div class="mb-3 container ">
                    <div class="row mb-3">
                        <div class="col-6 my-auto">
                            <h4 class="mb-0">Investigations</h4>
                        </div>
                        <div class="col-6 text-end">
                            <button class="btn btn-primary"
                                @click.prevent="handleInvestigationOutcomeClick()">Add</button>
                        </div>
                    </div>
                   <div class="row border" v-for="(investigation, index) in contactFullReport!.investigation_outcome">
                        <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-10 p-2">
                            <SelectField v-model="contactFullReport!.investigation_outcome![index]"
                                :select-items="contactsStore.getInvestigationOutcome" :is-horizontal="false"
                                :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                            </SelectField>
                        </div>
                        <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-2 p-2 mt-1 text-end">
                            <button class="btn-close me-3" aria-label="Remove"
                                @click.prevent="handleRemove(`investigation_outcome`, contactFullReport!.investigation_outcome, index)"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script setup lang="ts">
import { defineComponent, defineExpose, ref, computed } from 'vue';
import { useContactsStore } from '../../stores/contactsStore';
import { storeToRefs } from 'pinia';
import SelectField from '../Misc/SelectField.vue';
import Datepicker from '@vuepic/vue-datepicker'; //https://vue3datepicker.com
import '@vuepic/vue-datepicker/dist/main.css';
import { InvestigationOutcome, ComplaintOutcome } from './schema';
import useValidation from '../Misc/validationUtils';

const contactsStore = useContactsStore();

var entryIntoProperty = ref((contactsStore.contactFullReport!.entry_details?.warrant || contactsStore.contactFullReport!.entry_details?.unannounced_entry || contactsStore.contactFullReport!.entry_details?.person_present) as boolean);
var getEntryIntoProperty = computed(() => {
    if (entryIntoProperty.value === undefined) {
        entryIntoProperty.value = contactsStore.contactFullReport!.entry_details?.warrant || contactsStore.contactFullReport!.entry_details?.unannounced_entry || contactsStore.contactFullReport!.entry_details?.person_present;
    }
    if (entryIntoProperty.value != undefined) {
        return entryIntoProperty.value;
    }
    return false;
});
let form = document.getElementById("mainForm") as HTMLFormElement;

if (form && form != null && form.classList.contains('was-validated')) {
    form.classList.remove('was-validated');
}

const dateFormat = "yyyy-MM-dd'T'HH:mm:ss";

var { contactFullReport } = storeToRefs(useContactsStore());

const { validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray } = useValidation();
defineExpose({triggerValidation});
function handleInvestigationOutcomeClick() {
    if (!contactsStore.contactFullReport!["investigation_outcome"]) {
        contactsStore.contactFullReport!.investigation_outcome = [] as InvestigationOutcome[];
    }

    contactsStore.contactFullReport!.investigation_outcome.push('' as InvestigationOutcome);
}

function handleComplaintOutcomeClick() {
    if (!contactsStore.contactFullReport!.complaint_outcome) {
        contactsStore.contactFullReport!.complaint_outcome = [] as ComplaintOutcome[];
    }

    contactsStore.contactFullReport!.complaint_outcome.push('' as ComplaintOutcome);
}

function isAlternatingRow(index: number): boolean {
    return index % 2 == 1;
}

function handleRemove(name: string, array: any, index: number) {
    resetValidatableComponentArray();
    array.splice(index, index >= 0 ? 1 : 0);
}

function handleEntryChange() {
    if (entryIntoProperty.value) {
        contactsStore.contactFullReport!.entry_details = { warrant: false, person_present: false, unannounced_entry: false }
    }
    else {
        contactsStore.contactFullReport!.entry_details = undefined;
    }
}

function handleTimeStampUpdate(event: any) {
    contactsStore.contactFullReport!.timestamp = event.format(dateFormat);
    return false;
}

</script>